<template>
  <footer class="footer stylish-color-tiffanyBlue pt-4">
    <div class="container text-center text-md-left">
      <div class="row text-center text-md-left mt-3 pb-3">
        <div class="col-md-12 col-lg-3 col-xl-3 mx-auto mt-3">
          <a>
            <img class="logo" :src="logo" />
          </a>
        </div>

        <!-- <hr class="w-100 clearfix d-md-none" style="border-color: white" /> -->

        <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3">
          <h6 class="mb-4 font-weight-bold">Product</h6>
          <router-link
            style="color:white; white-space: nowrap;"
            class="link documentation"
            :to="'/docs'"
          >API Documentation</router-link>
          <p class="lower_link">
            <router-link style="color:white" class="pricing" :to="'/pricing'">Pricing</router-link>
          </p>
        </div>

        <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3 about">
          <h6 class="mb-4 font-weight-bold">About</h6>
          <p @click="goToAd" style="white-space: nowrap;">The Company</p>
          <p class="lower_link">
            <a href="mailto:support@unibit.ai">Careers</a>
          </p>
        </div>

        <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3">
          <h6 class="mb-4 font-weight-bold">Legal</h6>
          <a id="modal_link" data-toggle="modal" data-target="#privacy">Privacy policy</a>
          <privacy-policy-card></privacy-policy-card>
          <p class="lower_link">
            <a id="modal_link" data-toggle="modal" data-target="#terms">Terms of Use</a>
          </p>

          <term-use-card></term-use-card>
        </div>

        <!-- <hr class="w-100 clearfix d-md-none" style="border-color:white" /> -->
        <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mt-3">
          <h6 class="mb-4 font-weight-bold">Contact</h6>
          <p>support@unibit.ai</p>
          <a href="https://twitter.com/unibit_ai" target="_blank">
            <v-icon class="icon" name="twitter"></v-icon>
          </a>
          <a href="https://www.linkedin.com/company/unibit.inc/" target="_blank">
            <v-icon class="icon" name="linkedin"></v-icon>
          </a>
          <a href="https://github.com/unibit-api" target="_blank">
            <v-icon class="icon" name="github"></v-icon>
          </a>
        </div>
      </div>

      <!-- <hr style=" border-top: 0.2px solid white" /> -->
      <div style="marginBottom:1rem" class="row align-items-center">
        <p class="col-12 text-center text-md-center grey-text">
          © 2018 - {{new Date().getFullYear()}} Copyright
          <strong>Unibit.ai</strong>
        </p>
      </div>
    </div>
  </footer>
</template>
<script>
import PrivacyPolicyCard from "@/components/card/privacy-policy-card";
import TermUseCard from "@/components/card/term-use-card";

export default {
  components: {
    PrivacyPolicyCard,
    TermUseCard
  },
  data() {
    return {
      logo: require("@/assets/imgs/logo-white.png")
    };
  },

  methods: {
    goToAd() {
      this.$router.replace("/solution");
    }
  }
};
</script>
<style scoped lang="css">
.footer {
  /* bottom: 0; */
  position: relative;
}
.logo {
  width: 150px;
  margin-bottom: 25px;
}
.icon {
  fill: white;
  margin: 5px;
  margin-top: 1rem;
}

.lower_link {
  margin-top: 1rem;
}

.icon:hover {
  cursor: pointer;
}

.stylish-color-tiffanyBlue {
  background: #16abbd;
  color: #ffffff;
}

a:link {
  color: #fff;
}

a:focus {
  color: #fff;
}

a:visited {
  color: #fff;
}

.about > p:hover {
  text-decoration: underline;
  cursor: pointer;
}

#modal_link:hover {
  text-decoration: underline;
  cursor: pointer;
}
.icon {
  width: 24px;
}
</style>



// WEBPACK FOOTER //
// src/components/fixed/footer.vue